/*
Replace
nft with your resource Name :) Take care about different writings!
/!\ Nft nft Nfts nfts /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const contractTemplatesSlice = createSlice({
  name: "contractTemplates",
  initialState: { ...defaultInitialState, templateHelpersDictionary: {} },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: (state, action) => {
      defaultShowSuccess(state, action);
    },
    showFail: defaultShowFail,
    // create: defaultCreate,
    // createSuccess: defaultCreateSuccess,
    // createFail: defaultCreateFail,
    // update: defaultUpdate,
    // updateSuccess: defaultUpdateSuccess,
    // updateFail: defaultUpdateFail,
    addToDictionary: (state, action) => {
      defaultAddToDictionary(state, action);
      const { id, abi, devdoc } = action.payload?.attributes;
      if (id && abi && devdoc) {
        const { stateVariables, modules } = devdoc;
        let allStateVariables = { ...stateVariables };
        let allMethods = { ...devdoc.methods };
        let allModuleMethods = {};
        let allEvents = { ...devdoc.events };
        if (modules) {
          modules.forEach((module) => {
            const {
              stateVariables: moduleStateVariables,
              methods: moduleMethods,
              events: moduleEvents,
            } = module;
            allStateVariables = {
              ...allStateVariables,
              ...moduleStateVariables,
            };
            allMethods = { ...allMethods, ...moduleMethods };
            allEvents = { ...allEvents, ...moduleEvents };
            allModuleMethods = { ...allModuleMethods, ...moduleMethods };
          });
        }
        let mainContractMethods = {};
        let mainContractEvents = {};
        Object.keys(allMethods).forEach((methodName) => {
          if (!allModuleMethods[methodName]) {
            mainContractMethods[methodName] = allMethods[methodName];
          }
        });
        Object.keys(allEvents).forEach((eventName) => {
          if (!allModuleMethods[eventName]) {
            mainContractEvents[eventName] = allEvents[eventName];
          }
        });
        const mintTypes = [];
        const roleTypes = [];
        const stateVariableSetters = [];
        const stateVariableGetters = [];
        Object.keys(allStateVariables).forEach((stateVariable) => {
          const stateVariableEntry = allStateVariables[stateVariable];
          if (stateVariableEntry["custom:minttype"]) {
            mintTypes.push(stateVariable);
          }
          if (stateVariableEntry["custom:role"]) {
            roleTypes.push(stateVariable);
          }
          if (stateVariableEntry["custom:setter"]) {
            stateVariableSetters.push(stateVariableEntry["custom:setter"]);
          }
          if (stateVariableEntry["custom:getter"]) {
            stateVariableGetters.push(stateVariableEntry["custom:getter"]);
          }
        });

        state.templateHelpersDictionary[id] = {
          allStateVariables,
          allMethods,
          allEvents,
          mainContractMethods,
          mainContractEvents,
          allModuleMethods,
          mintTypes,
          roleTypes,
          stateVariableGetters,
          stateVariableSetters,
        };
      }
    },
    updateReset: (state, action) => {
      state.updating = false;
      state.updated = false;
      state.updateError = null;
    },
    listReset: (state, action) => {
      state.listing = false;
      state.listed = false;
      state.listError = null;
    },
    createReset: (state, action) => {
      state.creating = false;
      state.created = false;
      state.createError = null;
    },
  },
});

export const {
  // create: createContractTemplate,
  show: showContractTemplate,
  // update: updateContractTemplate,
  list: listContractTemplates,
  // updateReset: updateContractTemplateReset,
  listReset: listContractTemplateReset,
  // createReset: createContractTemplateReset,
} = contractTemplatesSlice.actions;
export const actions = contractTemplatesSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const contractTemplates = (state) =>
  state.contractTemplates.idsList.map(
    (id) => state.contractTemplates.dictionary[id]
  );
export const contractTemplate = (state) =>
  state.contractTemplates.showId &&
  state.contractTemplates.dictionary[state.contractTemplates.showId];
export const contractTemplateAttributes = (state) =>
  contractTemplate(state)?.attributes;
export const contractTemplateRelationships = (state) =>
  contractTemplate(state)?.relationships;
export const contractTemplateId = (state) => state.contractTemplates.showId;

export const getContractTemplate = createSelector(
  (state) => state.contractTemplates.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getContractTemplateAttributes = createSelector(
  (state) => state.contractTemplates.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getContractTemplateRelationships = createSelector(
  (state) => state.contractTemplates.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getContractTemplateHelpers = createSelector(
  (state) => state.contractTemplates.templateHelpersDictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getContractTemplates = createSelector(
  (state) => state.contractTemplates.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    if (!ids) return Object.keys(dictionary).map((id) => dictionary[id]);
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export const getContractTemplateOptions = (state) => {
  return Object.values(state.contractTemplates.dictionary).map(
    (contractTemplate) => ({
      value: contractTemplate.id,
      label: contractTemplate.attributes.name,
    })
  );
};

export default contractTemplatesSlice.reducer;
